import { SALESPERSON_COOKIE_KEY, SALESPERSON_PARAM_KEY } from "@/constants";
import { getCookie, setCookie } from "@/lib/cookie";

export const getSalesPersonData = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmSalesSource = urlParams.get("utm_source");
  const utmSalesName = urlParams.get("utm_campaign");
  const salesParams = urlParams.get(SALESPERSON_PARAM_KEY);
  let salesCode = null;

  if (utmSalesSource === "sales" && utmSalesName) {
    salesCode = utmSalesName;
  } else if (salesParams) {
    salesCode = salesParams;
  }

  if (salesCode) {
    return setCookie(SALESPERSON_COOKIE_KEY, salesCode);
  }

  const salesPersonShortCode = getCookie(SALESPERSON_COOKIE_KEY);

  if (salesPersonShortCode) {
    return salesPersonShortCode;
  }

  return null;
};
